// 必吃大瓜 全量吃瓜流短讯库（支持分类筛选与站内搜索）

export interface FeedItem {
  id: string;
  title: string;
  category: '综艺' | '影视' | '明星' | '行业';
  summary: string;
  timeLabel: string;
  source: string;
  hot: string;
  comment: number;
}

export const newsFeed: FeedItem[] = [
  {
    id: 'feed-01',
    title: '热播综艺收官夜收视创新高，网友：本季最大赢家是「真实」',
    category: '综艺',
    summary: '收官集全无预演的名场面接连上线，节目组主动放出的「翻车花絮」反成加分项，讨论区一片叫好。',
    timeLabel: '今日 08:50',
    source: '网友热议',
    hot: '96万',
    comment: 4821,
  },
  {
    id: 'feed-02',
    title: '国产科幻剧续订第二季，选角与世界观同步升级引期待',
    category: '影视',
    summary: '片方官宣原班主创回归，同时释出两张概念美术，视觉风格从冷硬科幻转向温暖奇观。',
    timeLabel: '今日 08:20',
    source: '官方消息',
    hot: '74万',
    comment: 3127,
  },
  {
    id: 'feed-03',
    title: '多位一线歌手官宣跨年演出行程，主办方提示理性购票',
    category: '行业',
    summary: '跨年演出季拉开序幕，业内人士提醒留意票务平台实名制与退改规则，谨防二手溢价。',
    timeLabel: '今日 07:55',
    source: '编辑部整理',
    hot: '88万',
    comment: 2910,
  },
  {
    id: 'feed-04',
    title: '老牌音乐节「重出江湖」，阵容公布后话题阅读量破亿',
    category: '行业',
    summary: '沉寂数年的音乐节品牌重启，集结老中青三代阵容，怀旧情绪与新鲜血液双向拉满。',
    timeLabel: '昨日 22:10',
    source: '现场直击',
    hot: '121万',
    comment: 5320,
  },
  {
    id: 'feed-05',
    title: '新晋演员剧组「被偶遇」引热议，业内提醒勿过度打扰创作',
    category: '明星',
    summary: '一段路人偶遇视频刷屏，片方呼吁给创作者留足空间，粉丝群体也自发倡议理性应援。',
    timeLabel: '昨日 21:30',
    source: '粉丝圈',
    hot: '63万',
    comment: 2180,
  },
  {
    id: 'feed-06',
    title: '经典老剧高清修复版上线，弹幕开启「全民考古」',
    category: '影视',
    summary: '多年前的经典剧目经4K修复重映，年轻观众涌入补课，弹幕区秒变怀旧现场。',
    timeLabel: '昨日 20:05',
    source: '站内精选',
    hot: '107万',
    comment: 6105,
  },
  {
    id: 'feed-07',
    title: '纪录片团队跟拍半年拍摄新作，聚焦小镇青年的舞台梦',
    category: '影视',
    summary: '非虚构新作上线，镜头对准剧场后台与聚光灯边缘，被赞「把素人的高光还给了素人」。',
    timeLabel: '本周四',
    source: '口碑新作',
    hot: '45万',
    comment: 1780,
  },
  {
    id: 'feed-08',
    title: '综艺嘉宾「反内卷」发言出圈，节目切片播放量三天破千万',
    category: '综艺',
    summary: '一句关于「允许自己慢下来」的表达戳中年轻人情绪，相关话题连续登顶热榜。',
    timeLabel: '本周四',
    source: '切片出圈',
    hot: '156万',
    comment: 8420,
  },
  {
    id: 'feed-09',
    title: '音乐平台发布年度听歌报告，用户热议「我的年度旋律」',
    category: '行业',
    summary: '一年一度的听歌盘点上线，网友自发分享年度单曲与深夜歌单，形成规模传播。',
    timeLabel: '本周三',
    source: '平台数据',
    hot: '134万',
    comment: 7230,
  },
  {
    id: 'feed-10',
    title: '新剧路透照流出引选角争议，剧方回应：一切以官宣为准',
    category: '明星',
    summary: '一张模糊路透图点燃讨论，剧方呼吁网友勿轻信非官方物料，最终阵容将在开机发布会公开。',
    timeLabel: '本周三',
    source: '辟谣速递',
    hot: '71万',
    comment: 2560,
  },
  {
    id: 'feed-11',
    title: '「情绪价值」成内容行业热词，编辑部盘点三大新消费信号',
    category: '行业',
    summary: '从疗愈系综艺到沉浸式展览，内容产品纷纷转向售卖情绪价值，编辑部梳理趋势脉络。',
    timeLabel: '本周二',
    source: '观察专栏',
    hot: '58万',
    comment: 1950,
  },
  {
    id: 'feed-12',
    title: '老牌卫视官宣下季招商阵容，多档新节目首度亮相',
    category: '综艺',
    summary: '平台推介会上多档待播综艺揭开面纱，题材覆盖文化、竞技与旅行，看点十足。',
    timeLabel: '本周二',
    source: '平台发布',
    hot: '83万',
    comment: 3088,
  },
  {
    id: 'feed-13',
    title: '「二创与版权」再成焦点，平台新规给剪辑爱好者划重点',
    category: '行业',
    summary: '二次创作管理规定更新，必吃大瓜帮你梳理「哪些能剪、哪些需授权」的实用边界。',
    timeLabel: '本周一',
    source: '政策解读',
    hot: '69万',
    comment: 4020,
  },
  {
    id: 'feed-14',
    title: '年初爆款剧主演「二搭」传闻不断，剧迷在线催更第三部',
    category: '影视',
    summary: '两位主演的同框营业引发无限联想，相关话题连续多日被粉丝刷上热门。',
    timeLabel: '本周一',
    source: '粉丝热议',
    hot: '112万',
    comment: 6510,
  },
  {
    id: 'feed-15',
    title: '年度盛典红毯官宣日期，造型与主持阵容成最大悬念',
    category: '明星',
    summary: '年度盛典进入倒计时，各路造型团队蓄势待发，网友已经开始在线押注红毯名场面。',
    timeLabel: '上周日',
    source: '官方消息',
    hot: '91万',
    comment: 3705,
  },
  {
    id: 'feed-16',
    title: '编辑部特别提醒：理性吃瓜「三查三不」守则请收好',
    category: '行业',
    summary: '面对真假难辨的信息流，必吃大瓜总结了一套实用的信息核查清单，帮你远离情绪绑架。',
    timeLabel: '长期置顶',
    source: '编辑部专栏',
    hot: '—',
    comment: 0,
  },
];